export default "__VITE_ASSET__c787f5a6__"